export const ACCESSORIES = 'Accessories';
export const ACV = 'ACV';
export const ALLOWANCE = 'Allowance';
export const APPLY_CHANGES = 'Apply Changes';
export const COST = 'Cost';
export const SALE = 'Sale';
export const RESIDUAL = 'Residual';
export const NAME = 'Name';
export const APR = 'APR';
export const BACK = 'Back';
export const BODY_STYLE = 'Body Style';
export const CASH_DEAL_LABEL = 'Cash Deal';
export const CODE = 'Code';
export const ID = 'ID';
export const CREDIT_DECISION_TOGGLE = 'Official Credit Decision';
export const DEAL_TYPE = 'Deal Type';
export const DRIVE_LINE = 'Drive Line';
export const ENGINE = 'Engine';
export const FEES = 'Fees';
export const FINANCE_DEAL_LABEL = 'Finance Deal';
export const FLEX_BUY_DEAL = 'Flex Buy';
export const FLEX_BUY_DEAL_LABEL = 'Flex Buy Deal';
export const FRONT = 'Front';
export const GENERIC_LAST_FIELD_CHANGED_ERROR = 'Adjustment did not return a valid payment.';
export const INCENTIVE_DUPLICATE_CODE = 'Duplicate code';
export const INCLUDE_TRADE_WITH_OFFER = 'Include trade with offer*';
export const INSTALL = 'Install';
export const INTERIOR_COLOR = 'Interior Color';
export const IS_BUYER_REGISTERED_OWNER = 'The buyer is the registered owner of this vehicle.';
export const LEASE_DEAL_LABEL = 'Lease Deal';
export const BALLOON_DEAL_LABEL = 'Balloon Deal';
export const IS_TRADE_IN_ACTIVE_LEASE = 'This trade-in has an active lease';
export const LIEN_HOLDER = 'Lienholder';
export const LIEN_HOLDER_ACCOUNT_NUMBER = 'Account/Loan Number';
export const LIEN_HOLDER_ADDRESS_BANK = 'Bank Address';
export const LIEN_HOLDER_ADDRESS_CITY = 'City';
export const LIEN_HOLDER_ADDRESS_STATE = 'State';
export const LIEN_HOLDER_ADDRESS_ZIP = 'ZIP';
export const LIEN_HOLDER_PHONE_NUMBER = 'Phone';
export const MONEY_FACTOR = 'MF';
export const MONEY_FACTOR_TYPE = 'MoneyFactor';
export const MSRP = 'MSRP';
export const NOT_AVAILABLE = 'N/A';
export const ODOMETER = 'Odometer';
export const STOCK_NUMBER = 'Stock Number';
export const STOCK_NUMBER_MAX_LENGTH = 30;
export const STOCK_NUMBER_MAX_LENGTH_ERROR = `Stock Number must be under ${STOCK_NUMBER_MAX_LENGTH} characters`;
export const PAYOFF = 'Payoff';
export const PAYOFF_DUE_DATE = 'Payoff Due Date';
export const PER_DIEM = 'Per Diem';
export const PERCENTAGE_SIGN = '%';
export const PROFIT = 'Profit';
export const PROGRAMS_AND_INCENTIVES_DC = 'Programs & Incentives';
export const INCENTIVES = 'Incentives';
export const PROTECTION_PRODUCTS = 'Protection Products';
export const PURCHASE = 'Purchase';
export const REQUIRED = 'Required';
export const REQUIRED_INDICATOR = 'required';
export const TAXES = 'Taxes';
export const TRANSMISSION = 'Transmission';
export const TYPE = 'Type';
export const VEHICLE_IS_REGISTERED_IN_SAME_STATE = 'The vehicle is registered in the same state as the new vehicle.';
export const VIN = 'VIN';
export const EXTERIOR_COLORS = ['Beige', 'Gray', 'White', 'Blue', 'Black', 'Red', 'Other'];
export const VEHICLE_CONDITION = ['Excellent', 'Very Good', 'Good', 'Fair'];
export const AUTO_SELECT_PROGRAM = 'Auto Select Program';

export const TOOLTIP_CONTENT_LEASE =
    'Automatically assigns the best-fit lender program to the deal. Selecting this will reset the rate, term, and incentives accordingly. The rate type switcher will be hidden.';
export const TOOLTIP_CONTENT_FINANCE =
    'Automatically assigns the best-fit lender program to the deal. Selecting this will reset the rate, term, and incentives accordingly.';

export enum DriveLineEnums {
    AllWheelDrive = 'AllWheelDrive',
    FourWheelDrive = 'FourWheelDrive',
    FrontWheelDrive = 'FrontWheelDrive',
    RearWheelDrive = 'RearWheelDrive'
}

export enum DriveLineLabelEnums {
    AWD = 'AWD',
    FourWD = '4WD',
    FWD = 'FWD',
    RWD = 'RWD'
}

export const DriveLineOptions = [
    { label: DriveLineLabelEnums.AWD, value: DriveLineEnums.AllWheelDrive },
    { label: DriveLineLabelEnums.FourWD, value: DriveLineEnums.FourWheelDrive },
    { label: DriveLineLabelEnums.FWD, value: DriveLineEnums.FrontWheelDrive },
    { label: DriveLineLabelEnums.RWD, value: DriveLineEnums.RearWheelDrive }
];

export const ZERO_WIDTH_SPACE = '\u200b';

export const INCENTIVE_FIELD_NAMES = {
    NAME: 'name',
    CODE: 'code',
    TYPE: 'type',
    AMOUNT: 'amount',
    PROGRAM: 'program'
} as const;

// Multi-scenario constants
export const DRAFT_DEAL_LIMIT = 3;

export const PRO_RATA_FEE_TYPE_ID = 1056;

// Mock recon item options - replace with actual data
export const RECON_ITEM_OPTIONS = [
    { label: 'Mechanical Repairs', value: 'mechanical-repairs' },
    { label: 'Body Work', value: 'body-work' },
    { label: 'Detailing', value: 'detailing' },
    { label: 'Tires', value: 'tires' },
    { label: 'Paint', value: 'paint' },
    { label: 'Interior', value: 'interior' },
    { label: 'Other', value: 'other' }
];

export const MAX_RECON_ITEMS = 15;

export const LENDER_ADDRESS_LOAD_ERROR_PREFIX_MESSAGE = "Couldn't load the lender address";
export const LENDER_ADDRESS_LOAD_ERROR_REFRESH = 'Refresh';
export const LENDER_ADDRESS_LOAD_ERROR_SUFFIX_MESSAGE = 'to try loading it again, or enter the address manually.';

/** Shown beside Auto Select Program when the entered term matches no lender program. */
export const NO_PROGRAM_FOR_TERM_MESSAGE = (months: number | string) => `No lender programs available for a ${months}-month term.`;

export const AUTO_SELECTED_LENDER_PROGRAM_BANNER_BODY =
    'A lender program was selected automatically to calculate this payment. To choose a different one, open ';
export const AUTO_SELECTED_LENDER_PROGRAM_BANNER_LINK = 'Programs & Incentives';
export const AUTO_SELECTED_LENDER_PROGRAM_BANNER_SUFFIX = '.';
